import './button.scss'

const handleMouseover = (mouseEvent, type) => {
    const button = mouseEvent.currentTarget
    const firstLine = button.querySelector('.button__first-line')
    const secondLine = button.querySelector('.button__second-line')
    const charsFirstLine = firstLine.querySelectorAll('span')
    const charsSecondLine = secondLine.querySelectorAll('span')
    
    charsFirstLine.forEach((char, i) => {
        setTimeout(() => {
            char.style.transform = `translateY(${type === 'over' ? '-100%' : '0'})`
        }, 0 + i * 50);
    })
    
    charsSecondLine.forEach((char, i) => {
        setTimeout(() => {
            char.style.transform = `translateY(${type === 'over' ? '-100%' : '100%'})`
        }, 0 + i * 50);
    })
}

const setMarkup = (button) => {
    const text = button.textContent
    const textChars = text.split('');
    const firstLine = document.createElement('span')
    const secondLine = document.createElement('span')
    button.textContent = ''
    firstLine.classList.add('button__first-line')
    secondLine.classList.add('button__second-line')
    
    textChars.forEach(char => {
        const span = document.createElement('span')
        span.textContent = char
        const isSpace = char.trim() === ''
        const cloneSpan = span.cloneNode(true)
        
        if (isSpace) {
            span.style.width = '0.4em'
            cloneSpan.style.width = '0.4em'
        }
        
        firstLine.append(span)
        secondLine.append(cloneSpan)
    })
    
    button.append(firstLine)
    button.append(secondLine)
    button.addEventListener('mouseover', (mouseEvent) => handleMouseover(mouseEvent, 'over'))
    button.addEventListener('mouseleave', (mouseEvent) => handleMouseover(mouseEvent, 'leave'))
}

const init = () => {
    const buttons = document.querySelectorAll('[data-button]')
    if (buttons.length) buttons.forEach(setMarkup)
}

init()